import React from "react";
import {
  CreditsBalanceProvider,
  useCreditsBalance,
} from "../../context/CreditsBalanceContext";
import FreemiumTrialIndicator, { shouldShowFreemiumTrial } from "./FreemiumTrialIndicator";

function FreemiumTrialStatus({ profile, hideActiveStatus }) {
  const { rawBalance, loading, error, refusalDetail } = useCreditsBalance();
  const eligible = !loading && (rawBalance || error)
    && shouldShowFreemiumTrial(profile, rawBalance);

  if (!eligible) return null;
  return (
    <FreemiumTrialIndicator
      profile={profile}
      balance={rawBalance}
      balanceUnavailable={Boolean(error)}
      refusalDetail={refusalDetail}
      hideActiveStatus={hideActiveStatus}
    />
  );
}

function FreemiumTrialShellContent({ profile, hideActiveStatus, hideStatus, children }) {
  return (
    <>
      {children}
      {hideStatus ? null : (
        <FreemiumTrialStatus profile={profile} hideActiveStatus={hideActiveStatus} />
      )}
    </>
  );
}

/**
 * hideStatus suppresses the trial banner in every state (routes such as
 * onboarding that must not show it); hideActiveStatus only hides the
 * informational "active" state while still surfacing warnings.
 */
export default function FreemiumTrialShell({
  profile,
  hideActiveStatus = false,
  hideStatus = false,
  children,
}) {
  const { providerPresent } = useCreditsBalance();
  if (providerPresent) {
    return (
      <FreemiumTrialShellContent profile={profile} hideActiveStatus={hideActiveStatus} hideStatus={hideStatus}>
        {children}
      </FreemiumTrialShellContent>
    );
  }

  return (
    <CreditsBalanceProvider profile={profile}>
      <FreemiumTrialShellContent profile={profile} hideActiveStatus={hideActiveStatus} hideStatus={hideStatus}>
        {children}
      </FreemiumTrialShellContent>
    </CreditsBalanceProvider>
  );
}
